import { Braces, Download, SquareDashedBottomCode } from 'lucide-react';
import { useContext } from 'react';

import { AppContext } from '@context';
import { downloadJson, getCurrentDateString } from '@helpers';
import { Feature, FeatureHoookParams } from '..';
import { lang } from '@lang';
import { selectCustomerName, useAppSelector } from '@state';
import { useDesign } from '@hooks';

type UseDownloadBlueprintFeatureParams = FeatureHoookParams;

export const useDownloadBlueprintFeature = (params: UseDownloadBlueprintFeatureParams = {}): Feature<null> => {
	const [controller] = useDesign();

	const customerName = useAppSelector(selectCustomerName);
	const blueprintId = controller?.kitchen?.context?.blueprint?.id ?? '';
	const downloadId = blueprintId === '' ? '' : `-${blueprintId.substring(blueprintId.length - 4, blueprintId.length)}`;

	const [disabled, tooltip] = (() => {
		if (!controller) return [true, lang.customer.tooltip.noController];
		return [false, lang.customer.tooltip.downloadBlueprint];
	})();

	return {
		name: 'downloadBlueprintFeature',
		label: lang.customer.label.downloadBlueprint,
		shortcut: '',
		tooltip,
		icon: (props = {}) => <Braces {...props} />,
		disabled,
		value: null,
		hidden: false,
		handler: () => {
			if (controller && controller.kitchen.context.blueprint) {
				console.log('Downloading blueprint...', { blueprintId, downloadId, customerName });
				const data = controller.kitchen.context.blueprint.serialize();
				const filename = `${customerName.toLowerCase().replace(' ', '-')}${downloadId}.${getCurrentDateString()}.rbp`;
				downloadJson(data, filename);
			}
		}
	};
};
